/* eslint-disable @typescript-eslint/no-explicit-any */
import store from 'store'

interface SharedArgs {
  key: string
  namespace: localStorageParentKeysEnum
}

interface LocalStorageGetterArg extends SharedArgs {
  parse?: boolean
}

interface LocalStorageSetterArg extends SharedArgs {
  stringify?: boolean
  value: any
}

export function getLocalStorage<T = any>({
  key,
  namespace,
  parse = false,
}: LocalStorageGetterArg): T | null {
  try {
    if (store.get(`${namespace}-${key}`)) {
      return parse
        ? JSON.parse(store.get(`${namespace}-${key}`))
        : store.get(`${namespace}-${key}`)
    }
    return null
  } catch (e) {
    if (e instanceof Error) {
      console.error('[Principles.LocalStorage.getLocalStorage]', e.message)
    } else {
      console.error('[Principles.LocalStorage.getLocalStorage] unknown error')
    }
    return null
  }
}

export const setLocalStorage = (
  settings: LocalStorageSetterArg | LocalStorageSetterArg[]
): void => {
  try {
    const setItem = (setting: LocalStorageSetterArg) => {
      const { key, namespace, value, stringify = false } = setting
      store.set(
        `${namespace}-${key}`,
        stringify ? JSON.stringify(value) : value
      )
    }
    return Array.isArray(settings)
      ? settings.forEach((setting) => setItem(setting))
      : setItem(settings)
  } catch (e) {
    if (e instanceof Error) {
      console.error('[Principles.LocalStorage.setLocalStorage]', e.message)
    } else {
      console.error('[Principles.LocalStorage.setLocalStorage] unknown error')
    }
  }
}

export enum localStorageParentKeysEnum {
  ASSIGNMENTS = 'assignments',
  GEM_COPILOT = 'gem-copilot',
  BOARDS = 'boards',
  CONTENT_COMPOSER = 'content-composer',
  CONTENT_CARD = 'content-card',
  TIMELINES = 'timelines',
  PREVIEWER = 'previewer',
  WEEKVIEW = 'weekview',
  PLACEMENTS_TIMELINES = 'placements-timelines',
  PLANS = 'plans',
  STORIES_VIEW = 'stories-view',
  SPREADSHEET_COMPONENT = 'spreadsheet-component',
}

export const localStorageParentKeys = {
  ASSIGNMENTS: 'assignments',
  GEM_COPILOT: 'gem-copilot',
  BOARDS: 'boards',
  CONTENT_COMPOSER: 'content-composer',
  CONTENT_CARD: 'content-card',
  TIMELINES: 'timelines',
  PREVIEWER: 'previewer',
  WEEKVIEW: 'weekview',
  PLACEMENTS_TIMELINES: 'placements-timelines',
  PLANS: 'plans',
  STORIES_VIEW: 'stories-view',
  SPREADSHEET_COMPONENT: 'spreadsheet-component',
}
